import { Link } from "react-router-dom";
import { ADMIN_ROUTES } from "../utils/router";
import { useSidebar } from "./Sidebar.hook";
import { AdminRoute } from "routes";
import { twMerge } from "tailwind-merge";

interface SidebarProps {
  isAdmin: boolean;
}

export default function Sidebar({ isAdmin }: SidebarProps) {
  const {
    models: { location },
    operations: { onLocationSelect },
  } = useSidebar(isAdmin);

  return (
    <nav className="w-sidebar flex min-w-[200px] flex-col gap-5 overflow-y-auto bg-black p-5">
      {Object.keys(ADMIN_ROUTES).map((key, index) => {
        const route = ADMIN_ROUTES[key as keyof AdminRoute];

        if (!route.show) {
          return null;
        }

        return (
          <div className="flex flex-col" key={`${key}-${index}`}>
            <p className="my-2 text-lg font-bold text-white">{route.name}</p>
            {Object.values(route.children!).map((child, index) => {
              if (!child.show) {
                return null;
              }

              const isSelected = location === child.path;

              return (
                <Link
                  key={child?.name || "" + index}
                  to={child.path || `link_${index}`}
                  onClick={() => {
                    onLocationSelect(child.path || "/");
                  }}
                >
                  <p
                    className={twMerge(
                      "m-1 mr-0 font-bold",
                      isSelected ? "text-blue-300" : "text-zinc-500"
                    )}
                    key={child.name}
                  >
                    {child.name}
                  </p>
                </Link>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
